import { fromJS } from 'immutable';

import ResponseTime from 'models/ResponseTimeModel';

import {
  REQUEST_RESPONSE_TIME,
  REQUEST_RESPONSE_TIME_SUCCESS,
  REQUEST_RESPONSE_TIME_FAILURE,
} from './types';

const initialState = fromJS({
  data: false,
  network: { loading: false, error: false },
});

export function responseTimeRequest() {
  return {
    type: REQUEST_RESPONSE_TIME,
  };
}

export function responseTimeSuccess(response) {
  return {
    type: REQUEST_RESPONSE_TIME_SUCCESS,
    response,
  };
}

export function responseTimeFailure(error) {
  return {
    type: REQUEST_RESPONSE_TIME_FAILURE,
    error,
  };
}

export default function responseTimeReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_RESPONSE_TIME:
      return state.setIn(['network', 'loading'], true);
    case REQUEST_RESPONSE_TIME_SUCCESS:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], false)
          .set('data', ResponseTime.deserialize(action.response)),
      );
    case REQUEST_RESPONSE_TIME_FAILURE:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], action.error)
          .set('data', false),
      );
    default:
      return state;
  }
}
